import { useTranslation } from 'react-i18next';
import QcModal from '@/components/Modal/Modal';
import { useModal } from '@/context/Modal.context';
import { MODAL_TYPES } from '@/context/Qualitycontrol.context';

type WarningModal = {
  warningMessage: string;
};

const WarningModal = () => {
  const { t } = useTranslation();

  const { setModalInfo, modal } = useModal();

  const onClose = () => {
    setModalInfo({
      modalType: '',
      modalInfo: {},
    });
  };

  const { modalType, modalInfo } = modal || {};

  const message =
    modalType === MODAL_TYPES.WARNING_INFO && modalInfo.warningMessage
      ? modalInfo?.warningMessage || ''
      : '';

  return (
    <QcModal
      open={true}
      maxWidth="xs"
      id="warning-modal"
      header={t('QC_V2.MAIN.ATTENTION')}
      content={<span>{message}</span>}
      actionButtons={{
        confirm: {
          onClick: onClose,
          text: t('QC_V2.MAIN.OK'),
        },
      }}
    />
  );
};

export default WarningModal;
